import React from 'react';
import { useContext } from 'react';
import { BinContext } from '../../../../../../../context/BinContext';
import { ContainerContext } from '../../../../../../../context/ContainerContext';
import { BinMutations, DeleteBinResponse, DeleteBinVariables } from '../../../../../../../graphql/bin.graphql';
import useMutation from '../../../../../../../hooks/useMutation';
import { useToast } from '../../../../../../../providers/ToastProvider';
import { Bin, BinInput } from '../../../../../../../types/bin';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { translate } from '../../../../../../../types/translation/Translator';
import { CancelButton, DeleteButton } from '../../../../../../components/Button';
import { AlertModal } from '../../../../../../components/Modal';
import { ToastType } from '../../../../../../components/Toast';

interface BinDeleteModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  bin: Bin;
}

export default function BinDeleteModal({ open, setOpen, bin }: BinDeleteModalProps) {
  const { showToast } = useToast();

  const { bins, setBins } = useContext(BinContext);
  const { containers, setContainers } = useContext(ContainerContext);

  const [remove, { loading }] = useMutation<DeleteBinResponse, DeleteBinVariables>(BinMutations.remove, {
    variables: { bins: [new BinInput(bin).forDelete()] },
    onCompleted: response => {
      const deletedBin = response.deleteBin[0];
      bins.delete(deletedBin.id);
      setBins(new Map(bins));
      containers.forEach(container => {
        if (container.binId === deletedBin.id) containers.delete(container.id);
      });
      setContainers(new Map(containers));
      showToast({
        type: ToastType.success,
        title: translate({ key: TranslationKey.binDeletedSuccessfullyToastTitle }),
      });
      setOpen(false);
    },
  });

  return (
    <AlertModal open={open} setOpen={setOpen} title={translate({ key: TranslationKey.deleteBinModalTitle })}>
      <div className='body-light grid gap-4'>
        <p>{translate({ key: TranslationKey.deleteBinModalPrimaryText })}</p>
        <p className='text-error-500'>{translate({ key: TranslationKey.deleteBinModalWarningText })}</p>
        <div className='flex items-center justify-end gap-2'>
          <CancelButton onClick={() => setOpen(false)} disabled={loading} />
          <DeleteButton onClick={() => remove()} loading={loading} />
        </div>
      </div>
    </AlertModal>
  );
}
